import * as s from './ToolbarLayout.module.scss'

interface IToolbarLayoutProps {
  children: React.ReactNode
}

const ToolbarLayout = ({ children }: IToolbarLayoutProps) => {
  return (
    <div className={s.root} onClick={(e) => e.stopPropagation()}>
      {children}
    </div>
  )
}

export default ToolbarLayout
